export default "__VITE_ASSET__DKr$DCYq__"